import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Linkedin, Facebook } from 'lucide-react';
import { IMAGES } from '../shared/constants';
import 'bootstrap/dist/css/bootstrap.min.css';
import './fielder_style.css';
import './Footer.css';

const CONTACT_EMAIL = process.env.REACT_APP_CONTACT_EMAIL || 'fielderusa@gmail.com';
const INSTAGRAM_URL = 'https://www.instagram.com/fielder.usa';
const LINKEDIN_URL = 'https://www.linkedin.com/company/fielder-usa/';
const FACEBOOK_URL = 'https://www.facebook.com/share/1D1difJ3KP/';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="fielder-footer">
      <div className="container py-5">
        <div className="row gy-4">

          {/* Brand */}
          <div className="col-12 col-lg-6">
            <Link to="/" className="d-inline-flex align-items-center mb-3">
              <img src={IMAGES.FIELDER_LOGO} alt="Fielder" style={{ height: '32px' }} />
            </Link>
            <p className="fielder-footer__tagline mb-3">
              The DMV&rsquo;s marketplace for soccer field rentals. Find open fields,
              book in seconds, and play.
            </p>
            <div className="d-flex align-items-center gap-3">
              <a
                className="fielder-footer__social"
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Fielder on Instagram"
              >
                <Instagram size={20} />
              </a>
              <a
                className="fielder-footer__social"
                href={LINKEDIN_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Fielder on LinkedIn"
              >
                <Linkedin size={20} />
              </a>
              <a
                className="fielder-footer__social"
                href={FACEBOOK_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Fielder on Facebook"
              >
                <Facebook size={20} />
              </a>
            </div>
          </div>

          {/* Company */}
          <div className="col-6 col-lg-3">
            <h2 className="fielder-footer__heading mb-3">Company</h2>
            <ul className="list-unstyled d-flex flex-column gap-2 mb-0">
              <li><Link className="fielder-footer__link" to="/about">About</Link></li>
              <li><Link className="fielder-footer__link" to="/help">Help</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="col-6 col-lg-3">
            <h2 className="fielder-footer__heading mb-3">Contact</h2>
            <ul className="list-unstyled d-flex flex-column gap-2 mb-0">
              <li>
                <a className="fielder-footer__link" href={`mailto:${CONTACT_EMAIL}`}>
                  {CONTACT_EMAIL}
                </a>
              </li>
            </ul>
          </div>

        </div>
      </div>

      <div className="fielder-footer__bottom">
        <div className="container py-3">
          &copy; {year} Fielder. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
